module.exports = __webpack_public_path__ + "img/logoblanco.3f80bd7d.png";